export interface SystemStatusProps {
  hasError: boolean;
  loading: boolean;
  loadingCount?: number;
  statusPageUrl: string;
  systemStatuses?: SystemStatus[];
}

export interface SystemStatus {
  name: string;
  statusType: SystemStatusTypes;
}

export enum SystemStatusTypes {
  error = "error",
  success = "success",
  warning = "warning",
}
